import { render } from "./FooterElement.vue?vue&type=template&id=7ca11ae5"
import script from "./FooterElement.vue?vue&type=script&lang=js"
export * from "./FooterElement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__